import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/land.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "bottom-tab" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "tab-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h1", null, [
        _createElementVNode("span", { class: "zhejiang" }, "浙江"),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "land",
          class: "land-icon"
        }),
        _createElementVNode("span", { class: "dayou" }, "大有")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTab.component)))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["tab-item", { active: _ctx.activeTab === index }]),
          onClick: ($event: any) => (_ctx.switchTab(index))
        }, [
          _createElementVNode("img", {
            src: _ctx.activeTab === index ? tab.activeIcon : tab.icon,
            alt: tab.name,
            class: "tab-icon"
          }, null, 8, _hoisted_5),
          _createElementVNode("span", _hoisted_6, _toDisplayString(tab.name), 1)
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}